import Swal from 'sweetalert2/dist/sweetalert2'
import i18n from '../i18n.js';

// Maximální velikost nahrávaného souboru – musí odpovídat FileUploadService::MAX_FILE_SIZE_KB na serveru
export const MAX_FILE_SIZE = 32 * 1024 * 1024;

/**
 * Zkontroluje velikost souboru před uploadem. Při překročení limitu ukáže přeloženou hlášku
 * a vrátí false – volající pak soubor nepřijme a request vůbec neodešle.
 */
export function checkFileSize(file) {
    if (file && file.size > MAX_FILE_SIZE) {
        Swal.fire({
            icon: 'error',
            text: i18n.global.t('file.fileTooLarge'),
        });
        return false;
    }
    return true;
}
